import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';
import {
  HubNotification,
  UserHubNotification,
  CreateNotificationRequest,
  UpdateNotificationRequest,
} from '@models/notification.model';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private readonly baseUrl = `${environment.apiUrl}/Notifications`;

  constructor(private http: HttpClient) {}

  getNotifications(showInactive: boolean): Observable<HubNotification[]> {
    return this.http.get<HubNotification[]>(this.baseUrl, {
      params: { showInactive: showInactive.toString() },
    });
  }

  getUserNotifications(organizationId: number): Observable<UserHubNotification[]> {
    return this.http.get<UserHubNotification[]>(`${this.baseUrl}/user`, {
      params: { organizationId: organizationId.toString() },
    });
  }

  createNotification(req: CreateNotificationRequest): Observable<HubNotification> {
    return this.http.post<HubNotification>(this.baseUrl, req);
  }

  updateNotification(req: UpdateNotificationRequest): Observable<HubNotification> {
    return this.http.put<HubNotification>(`${this.baseUrl}/${req.id}`, req);
  }

  deleteNotification(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }

  reactivateNotification(id: number): Observable<void> {
    return this.http.patch<void>(`${this.baseUrl}/${id}/reactivate`, {});
  }

  markAsRead(notificationId: number): Observable<void> {
    return this.http.patch<void>(`${this.baseUrl}/${notificationId}/read`, {});
  }

  markAsUnread(notificationId: number): Observable<void> {
    return this.http.patch<void>(`${this.baseUrl}/${notificationId}/unread`, {});
  }
}
